import UserDetail from "../../Portal/Admin/UserDetail";
import AdminHome from "../../Pages/AdminHome";
import Users from "../../Portal/Admin/Users";
import RegisterUsersCSV from "../../Portal/Admin/RegisterUsersCSV";
import Credits from "../../Portal/Admin/Credits";
import AddCredits from "../../Portal/Admin/AddCredits";
import RefundCredits from "../../Portal/Admin/RefundCredits";
import ApproveRefund from "../../Portal/Admin/ApproveRefund";
import PaymentCreditsRefunds from "../../Portal/Admin/PaymentCreditsRefunds";
import CreditUnits from "../../Portal/Admin/CreditUnits";
import CreditUnitDetail from "../../Portal/Admin/CreditUnitDetail";
import FinanceReport from "../../Portal/Admin/FinanceReport";
import FinanceReportResult from "../../Portal/Admin/FinanceReportResult";
import Developments from "../../Portal/Admin/Developments";
import Projects from "../../Portal/Admin/Projects";
import SimulationByUserName from "../../Portal/Admin/SimulationByUserName";

const AdminUserRouters = [
    {
      path: "Admin/Home",
      exact: true,
      requireAuth: true,
      element: <AdminHome />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/Users/Detail/:id",
      exact: true,
      requireAuth: true,
      element: <UserDetail />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/Users",
      exact: true,
      requireAuth: true,
      element: <Users />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/Users/RegisterUsersCSV",
      exact: true,
      requireAuth: true,
      element: <RegisterUsersCSV />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/Credits/:id",
      exact: true,
      requireAuth: true,
      element: <Credits />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/Credits/AddCredits/:id",
      exact: true,
      requireAuth: true,
      element: <AddCredits />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/Credits/Refund/:id",
      exact: true,
      requireAuth: true,
      element: <RefundCredits />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/Credits/Refund/Approve/:jsonParam",
      exact: true,
      requireAuth: true,
      element: <ApproveRefund />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/PaymentCredits",
      exact: true,
      requireAuth: true,
      element: <PaymentCreditsRefunds paymentType="Credit"/>,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/PaymentRefunds",
      exact: true,
      requireAuth: true,
      element: <PaymentCreditsRefunds paymentType="Refund"/>,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/CreditUnits",
      exact: true,
      requireAuth: true,
      element: <CreditUnits />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/CreditUnits/New",
      exact: true,
      requireAuth: true,
      element: <CreditUnitDetail />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/FinanceReport",
      exact: true,
      requireAuth: true,
      element: <FinanceReport />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/FinanceReport/Result/:jsonParam",
      exact: true,
      requireAuth: true,
      element: <FinanceReportResult />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/Developments",
      exact: true,
      requireAuth: true,
      element: <Developments />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/Projects",
      exact: true,
      requireAuth: true,
      element: <Projects />,
      title: "Admin | AccuRate Enterprise",
    },
    {
      path: "Admin/SimulationByUserName",
      exact: true,
      requireAuth: true,
      element: <SimulationByUserName />,
      title: "Admin | AccuRate Enterprise",
    }
  ];
  export default AdminUserRouters;